// Section title on the left, one line of context on the right.
// Pass title as an array to control where it breaks; each line rises out of its own mask.
export default function SectionHeading({ title, intro, id }) {
  const lines = Array.isArray(title) ? title : [title];
  return (
    <header className="section-head">
      <h2 id={id} className="section-title" data-reveal="title">
        {lines.map((line, i) => (
          <span className="title-mask" key={line} style={{ '--line': i }}>
            <span>{line}</span>
          </span>
        ))}
      </h2>
      {intro && <p className="section-intro" data-reveal style={{ '--i': 2 }}>{intro}</p>}
    </header>
  );
}
